module.exports = __webpack_public_path__ + "static/img/1.486baa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/1.png
// module id = Pybz
// module chunks = 0